(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[311],{

/***/ 28093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(67294);
var MDX = __webpack_require__(36921);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var MDX__namespace = /*#__PURE__*/_interopNamespace(MDX);

if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      var start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start))
          },
        });
      }, 1)
    };

  window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
      clearTimeout(id);
    };
}

/**
 * Renders compiled source from next-mdx-remote/serialize.
 */
function MDXRemote({ compiledSource, scope, components = {}, lazy, }) {
    const [isReadyToRender, setIsReadyToRender] = React.useState(!lazy || typeof window === 'undefined');
    // if we're on the client side and `lazy` is set to true, we hydrate the
    // mdx content inside requestIdleCallback, allowing the page to get to
    // interactive quicker, but the mdx content to hydrate slower.
    React.useEffect(() => {
        if (lazy) {
            const handle = window.requestIdleCallback(() => {
                setIsReadyToRender(true);
            });
            return () => window.cancelIdleCallback(handle);
        }
    }, []);
    const Content = React.useMemo(() => {
        // if we're ready to render, we can assemble the component tree and let React do its thing
        // first we set up the scope which has to include the mdx custom
        // create element function as well as any components we're using
        const fullScope = Object.assign({ mdx: MDX__namespace.mdx, React: React__default['default'] }, scope);
        const keys = Object.keys(fullScope);
        const values = Object.values(fullScope);
        // now we eval the source code using a function constructor
        // in order for this to work we need to have React, the mdx createElement,
        // and all our components in scope for the function, which is the case here
        // we pass the names (via keys) in as the function's args, and execute the
        // function with the actual values.
        const hydrateFn = Reflect.construct(Function, keys.concat(`${compiledSource}; return MDXContent;`));
        return hydrateFn.apply(hydrateFn, values);
    }, [scope, compiledSource]);
    if (!isReadyToRender) {
        // If we're not ready to render, return an empty div to preserve SSR'd markup
        return (React__default['default'].createElement("div", { dangerouslySetInnerHTML: { __html: '' }, suppressHydrationWarning: true }));
    }
    // wrapping the content with MDXProvider will allow us to customize the standard
    // markdown components (such as "h1" or "a") with the "components" object
    const content = (React__default['default'].createElement(MDX__namespace.MDXProvider, { components: components },
        React__default['default'].createElement(Content, null)));
    // If lazy = true, we need to render a wrapping div to preserve the same markup structure that was SSR'd
    return lazy ? React__default['default'].createElement("div", null, content) : content;
}

exports.R = MDXRemote;


/***/ }),

/***/ 36921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MDXContext": function() { return /* binding */ MDXContext; },
/* harmony export */   "MDXProvider": function() { return /* binding */ MDXProvider; },
/* harmony export */   "mdx": function() { return /* binding */ createElement; },
/* harmony export */   "useMDXComponents": function() { return /* binding */ useMDXComponents; },
/* harmony export */   "withMDXComponents": function() { return /* binding */ withMDXComponents; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};

var MDXContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var withMDXComponents = function withMDXComponents(Component) {
  return function (props) {
    var allComponents = useMDXComponents(props.components);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _extends({}, props, {
      components: allComponents
    }));
  };
};
var useMDXComponents = function useMDXComponents(components) {
  var contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext);
  var allComponents = contextComponents;

  if (components) {
    allComponents = isFunction(components) ? components(contextComponents) : _objectSpread2(_objectSpread2({}, contextComponents), components);
  }

  return allComponents;
};
var MDXProvider = function MDXProvider(props) {
  var allComponents = useMDXComponents(props.components);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(MDXContext.Provider, {
    value: allComponents
  }, props.children);
};

var TYPE_PROP_NAME = 'mdxType';
var DEFAULTS = {
  inlineCode: 'code',
  wrapper: function wrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}, children);
  }
};
var MDXCreateElement = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
  var propComponents = props.components,
      mdxType = props.mdxType,
      originalType = props.originalType,
      parentName = props.parentName,
      etc = _objectWithoutProperties(props, ["components", "mdxType", "originalType", "parentName"]);

  var components = useMDXComponents(propComponents);
  var type = mdxType;
  var Component = components["".concat(parentName, ".").concat(type)] || components[type] || DEFAULTS[type] || originalType;

  if (propComponents) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _objectSpread2(_objectSpread2({
      ref: ref
    }, etc), {}, {
      components: propComponents
    }));
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _objectSpread2({
    ref: ref
  }, etc));
});
MDXCreateElement.displayName = 'MDXCreateElement';
function createElement (type, props) {
  var args = arguments;
  var mdxType = props && props.mdxType;

  if (typeof type === 'string' || mdxType) {
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = MDXCreateElement;
    var newProps = {};

    for (var key in props) {
      if (hasOwnProperty.call(props, key)) {
        newProps[key] = props[key];
      }
    }

    newProps.originalType = type;
    newProps[TYPE_PROP_NAME] = typeof type === 'string' ? type : mdxType;
    createElementArgArray[1] = newProps;

    for (var i = 2; i < argsLength; i++) {
      createElementArgArray[i] = args[i];
    }

    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, args);
}




/***/ }),

/***/ 96701:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[year]/[month]/[day]/[slug]",
      function () {
        return __webpack_require__(91850);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2908:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Purple Booth Mark.555a1209.svg","height":620,"width":820});

/***/ }),

/***/ 92152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _nav_full_LogoHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29727);


var Spinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-testid": "Spinner",
        className: "prose flex h-screen min-w-full items-center justify-center transition-all delay-100 duration-150 ease-in-out motion-safe:animate-spin dark:prose-invert",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nav_full_LogoHeader__WEBPACK_IMPORTED_MODULE_1__/* .LogoHeader */ .S, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 61053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ IndexItemCategories; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var IndexItemCategories = function(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: "flex list-none flex-row flex-wrap gap-1 pl-0 font-bold",
        children: categories.map(function(tag, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: "m-0 inline-block whitespace-nowrap rounded bg-slate-100 p-1 dark:bg-slate-900",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/categories/".concat(encodeURIComponent(tag.toLowerCase()), "/"),
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        "data-testid": "IndexItemCategories ".concat(tag, " a"),
                        className: "font-bold no-underline",
                        children: tag
                    })
                })
            }, tag + index);
        })
    });
};


/***/ }),

/***/ 48988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IndexItemStatsLine; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66003);



var IndexItemStatsLine = function(param) {
    var readLengthMin = param.readLengthMin, date = param.date;
    var timestamp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return new Intl.NumberFormat(undefined, {
            style: "unit",
            unit: "minute"
        }).format(readLengthMin);
    }, [
        readLengthMin
    ]);
    var formattedDate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return date ? (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date) + " \xb7 " : "";
    }, [
        date
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "IndexItemStatsLine",
        className: "text-slate-600 dark:text-slate-400",
        children: [
            formattedDate,
            " ",
            timestamp,
            " read"
        ]
    });
};


/***/ }),

/***/ 96250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ IndexItemTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Heading2 = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
        "data-testid": "IndexItemTitle h2",
        className: "mb-1",
        children: children
    });
};
var Heading1 = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        "data-testid": "IndexItemTitle h1",
        className: "mb-1",
        children: children
    });
};
var IndexItemTitle = function(param) {
    var title = param.title, pageHasTitle = param.pageHasTitle;
    if (pageHasTitle) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading2, {
            children: title
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading1, {
        children: title
    });
};


/***/ }),

/***/ 29727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ LogoHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/Purple Booth Logo-01.svg
/* harmony default export */ var Purple_Booth_Logo_01 = ({"src":"/_next/static/media/Purple Booth Logo-01.f744b19e.svg","height":929,"width":1385});
;// CONCATENATED MODULE: ./components/nav/full/LightLogo.tsx




var LightLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        passHref: true,
        href: "/",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "data-testid": "LightLogo",
            className: "dark:hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                layout: "intrinsic",
                src: Purple_Booth_Logo_01,
                alt: "Purple Booth Ltd.",
                width: "320",
                height: "215",
                unoptimized: true
            })
        })
    });
};

// EXTERNAL MODULE: ./public/Purple Booth Mark.svg
var Purple_Booth_Mark = __webpack_require__(2908);
;// CONCATENATED MODULE: ./components/nav/full/DarkLogo.tsx




var DarkLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "m-10 hidden aspect-square items-center justify-center rounded-full bg-slate-100 p-5 dark:flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            passHref: true,
            href: "/",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                "data-testid": "DarkLogo",
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "intrinsic",
                    src: Purple_Booth_Mark/* default */.Z,
                    width: "200",
                    height: "200",
                    alt: "Purple Booth Ltd.",
                    unoptimized: true
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/nav/full/LogoHeader.tsx



var LogoHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        "data-testid": "LogoHeader",
        className: "cursor-pointer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightLogo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DarkLogo, {})
        ]
    });
};


/***/ }),

/***/ 91850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19288);
/* harmony import */ var next_mdx_remote__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28093);
/* harmony import */ var _components_index_IndexItemStatsLine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48988);
/* harmony import */ var _components_index_IndexItemCategories__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61053);
/* harmony import */ var _components_index_IndexItemTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96250);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_Spinner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92152);










var Layout = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(947), __webpack_require__.e(641)]).then(__webpack_require__.bind(__webpack_require__, 1641));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1641)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Spinner__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {});
    }
});
var IndexPage = function(param) {
    var article = param.article, contents = param.contents;
    if (!article || !contents) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_1__["default"], {
                statusCode: 404
            })
        });
    }
    var articleDate = article.meta.date ? (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(article.meta.date) : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Layout, {
        pageTitle: article.meta.title,
        pageDescription: article.meta.description,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
            className: "mb-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index_IndexItemTitle__WEBPACK_IMPORTED_MODULE_4__/* .IndexItemTitle */ .l, {
                    title: article.meta.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index_IndexItemStatsLine__WEBPACK_IMPORTED_MODULE_2__/* .IndexItemStatsLine */ .Z, {
                    readLengthMin: article.meta.readLengthMin,
                    date: articleDate
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index_IndexItemCategories__WEBPACK_IMPORTED_MODULE_3__/* .IndexItemCategories */ .K, {
                    categories: article.meta.categories
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "prose my-2 dark:prose-invert",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_mdx_remote__WEBPACK_IMPORTED_MODULE_8__/* .MDXRemote */ .R, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, contents))
                })
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,406,774,888,179], function() { return __webpack_exec__(96701); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);